<div
  class="autopay-widget d-flex align-items-center justify-content-between gap-12"
  [class]="AutoPayStatus[autoPayData.status]"
>
  <div class="left d-flex align-items-center gap-12">
    <i class="icon ic-autopay-20"></i>

    <div>
      <div class="autopay-title font-size-16">Autopay</div>

      @if (autoPayData.status == AutoPayStatus.NotFilled) {
        <div class="color-gray-700 font-size-12">
          Bank Account Number
        </div>
      } @else if (autoPayData.status == AutoPayStatus.PendingSignature) {
        <div class="font-size-12 color-blue">
          Pending Changes
        </div>
      } @else {
        <div class="bank-data">
          <div>BSB</div>
          <div>{{ autoPayData.bsb | bsb }}</div>

          <div>AN</div>
          <div>{{ accountName }}</div>
        </div>
      }
    </div>
  </div>

  <div class="right">
    @if (autoPayData.status == AutoPayStatus.NotFilled) {
      <button
        type="button"
        class="btn btn-secondary btn-icon"
        ngbTooltip="Send Agreement"
        tooltipClass="tooltip-info"
        [disabled]="modalOpened"
        (click)="openAddBankDataModal()"
      >
        <i class="icon ic-sent-mail-20"></i>
      </button>
    } @else if (autoPayData.status == AutoPayStatus.PendingSignature) {
      <button
        type="button"
        class="btn btn-secondary btn-icon"
        ngbTooltip="Void Agreement"
        tooltipClass="tooltip-info"
        [disabled]="modalOpened"
        (click)="voidEmail()"
      >
        <i class="icon ic-void-mail-20"></i>
      </button>
    } @else {
      <div ngbDropdown>
        <button
          ngbDropdownToggle
          type="button"
          class="btn btn-secondary btn-icon"
          [disabled]="modalOpened"
        >
          <i class="icon ic-more-horizontal-20"></i>
        </button>

        <div ngbDropdownMenu class="common-dropdown-menu">
          <button
            ngbDropdownItem
            type="button"
            (click)="toggleAutopay(autoPayData.status)"
          >
            <i
              class="icon"
              [class]="autoPayData.status == AutoPayStatus.TurnedOn ? 'ic-autopay-off-20' : 'ic-autopay-on-20'"
            ></i>
            <span>AutoPay {{ autoPayData.status == AutoPayStatus.TurnedOn ? 'Off' : 'On' }}</span>
          </button>

          <button
            ngbDropdownItem
            type="button"
            (click)="editAndSendNewDDA()"
          >
            <i class="icon ic-edit-and-send-20"></i>
            <span>Edit and Send New DDA</span>
          </button>


          <button
            ngbDropdownItem
            type="button"
            (click)="deleteAutoPayData()"
          >
            <i class="icon ic-trash-20"></i>
            <span>Delete</span>
          </button>
        </div>
      </div>
    }
  </div>
</div>
